// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_labor_management_mfe_styles" + "." + "ed1427a0" + ".chunk.css";
};